import * as _ from 'underscore'
import * as moment from 'moment'

import dxPopup, { dxPopupOptions } from 'devextreme/ui/popup'
import { dxButtonOptions } from 'devextreme/ui/button'
import { dxToolbarOptions } from 'devextreme/ui/toolbar'
import { dxFormOptions } from 'devextreme/ui/form'
import dxAccordion from 'devextreme/ui/accordion'

import { OpConfigurationProfile, OpConfigurationProfileData, OpConfigurationProfileType, OpDataType, OpDataTypeInGroup, OpDescr, } from '../../../../models/core'
import { Enums } from '../../../../models/common/enums'
import { IOpData, IOpObject, IReferenceType } from '../../../../models/util/interfaces'

import { EventsNames, LocalizationHelper, CommonHelper, TemplateHelper, ConfigHelper, TypeHelper, Dictionary, ConvertHelper, Md5, ReferenceTypeComponent, ToastHelper } from '../../../../helpers'

import { Api } from '../../../../modules/api/api.provider'
import { LocalDictionaryFactory } from '../../../../modules/api/api.local-dictionary.factory'
import { ReferenceTypeService } from '../../../../services/reference-type'
import { OperatorSecurityService } from '../../../../services/operator'

import { CreateEditScope } from '../../../common/common.create-edit.controller'
import { CreateEditInitParams, CreateEditPopupOptions } from '../../../common/create-edit-popup/create-edit-popup.controller'
import { UserSessionService } from '../../../../services/user-session'
import { ConfigurationProfileService } from '../../../../services/configuration-profile'
import { CommonCreateEdit, CreateEditField, CreateEditFieldSettings, CreateEditSection } from '../../../../modules/common/common.create-edit'
import { IMRAccordionItemOptions, IMRAccordionOptions } from '../../../../modules/common/accordion'
import { ChangeStatusSelectItem } from '../../../../modules/common/change-status/change-status.directive.controller'
import { OpCoord } from '../../../../models/custom/op-map-area'
import { IIMRConfigurationProfileSchedule, IIMRConfigurationProfileScheduleSubmitResponse, IMRConfigurationProfileScheduleInitializedArgs, IMRConfigurationProfileScheduleOptions } from '../../configuration-profile-schedule/configuration-profile-schedule.interfaces'
import { FieldNameValueModel } from '../../../../modules/api/api.models'
import { OpDataList } from '../../../../models/util'

export type ConfigurationProfileCreateEditOptions = {
    opConfigurationProfile: OpConfigurationProfile

    onSubmitCallback: (opDevice: any) => void
    onValidationCallback: (valid: boolean) => void
}

type SelectPopoverData = {
    valueId: number
    dataTypeId: number
    value: string
}

interface ConfigurationProfileCreateEditScope extends CreateEditScope {
    popupOptions: dxPopupOptions
    closeButtonOptions: dxButtonOptions
    popupVisible: boolean
    modelId: number
    panels: CreateEditSection[]

    dateFormat: string
    isLoading: boolean
    noData: boolean
    unsupportedConfigurationProfileTypeText: string

    locationDataChangePopupId: string

    toolbarOptions: dxToolbarOptions

    options: CreateEditPopupOptions

    // location type
    getCoords(): any
    onLocationSelected(lat: number, lng: number): void
    onPopoverValueIdSelected(valueId: number, dataTypeId: number, value: string): void

    // types / lists
    typeListsNames: string[]

    // locationData: LocationData
    // confirmNoChangePrevLocationData: () => void

    configurationProfileCreateEditAccordionsOptions: IMRAccordionOptions
    configurationProfileBaseParametersFormAccordionItemOptions: IMRAccordionItemOptions
    configurationProfileSettingsAccordionItemOptions: IMRAccordionItemOptions
    configurationProfileScheduleOptions: IMRConfigurationProfileScheduleOptions

    //localization
    confirmText: string
    noDataText: string

    isEditAllowed: boolean

    isSupportedType: boolean
}

export class ConfigurationProfileCreateEditPopupController extends CommonCreateEdit {

    // #region Members

    public editedItems: any = {} //!    

    // private configurationProfile: OpConfigurationProfile

    private originalData: CreateEditField[]
    private idReferenceType: number
    private referenceObject: IReferenceType & IOpObject

    private entityId: number = null

    private popup: dxPopup
    private accordion: dxAccordion

    private previousSectionState: string
    private isClosed: boolean
    private selectedPopoverData: SelectPopoverData[] = []

    private configurationProfileSchedule: IIMRConfigurationProfileSchedule

    private submitFailed: boolean = false

    private isSaveAllowed: boolean
    // #endregion


    // #region Ctor

    constructor(
        protected $scope: ConfigurationProfileCreateEditScope,
        private $compile: ng.ICompileService,
        protected $q: ng.IQService,
        protected $timeout: ng.ITimeoutService,
        protected api: Api,
        protected localDictionary: LocalDictionaryFactory,
        protected userSession: UserSessionService,
        protected referenceTypeService: ReferenceTypeService,
        protected readonly operatorSecurityService: OperatorSecurityService,
        protected configurationProfileService: ConfigurationProfileService
    ) {
        super($scope, api, localDictionary, $q, $timeout, userSession, referenceTypeService, operatorSecurityService)

        this.setEvents()
        this.setOptions()
    }

    // #endregion


    // #region Events

    private setEvents(): void {
        this.$scope.$on(EventsNames.ESC_KEY_PRESS, () => {
            if (this.$scope.popupOptions != null) {
                this.$timeout(() => {
                    this.closePopup()
                })
            }
        })

        // show popup
        this.$scope.$on(EventsNames.SHOW_CREATE_EDIT_POPUP, (event, ...args: any[]) => {
            this.onShowCreateEditPopup()
        })

        // initialize panels with forms and grids
        this.$scope.$on(EventsNames.OPEN_CREATE_EDIT_POPUP_CONFIGURATION_PROFILE, (event: ng.IAngularEvent, ...args: any[]) => {
            if (this.isClosed) {
                this.$scope.isLoading = false

                return
            }

            this.onShowPopup(args)
        })

        // close
        this.$scope.$on(EventsNames.CLOSE_CREATE_EDIT_POPUP, (event: ng.IAngularEvent, ...args: any[]) => {
            this.onCloseCreateEditPopup(args)
        })
    }

    // #endregion


    // #region Setup

    private setOptions(): void {
        this.$scope.noDataText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoData)
        this.$scope.confirmText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Confirm)
        this.$scope.unsupportedConfigurationProfileTypeText = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.UnsupportedConfigurationProfileType)

        //popup
        this.$scope.dateFormat = window['simax'].getDateFormat('DATE_FORMAT_DX')
        this.$scope.popupVisible = false

        this.$scope.popupOptions = {
            bindingOptions: {
                visible: 'popupVisible',
                title: 'options.title',
            },
            fullScreen: false,
            showTitle: true,
            closeOnOutsideClick: false,
            maxWidth: (): number => {
                return $(window).width() * 0.7
            },
            height: (): number => {
                return $(window).height() * 0.9
            },
            onHiding: (e: any): void => this.closePopup(),
            onInitialized: (e: any): void => {
                this.popup = e.component
            },
            onShowing: (e: any): void => {
                this.previousSectionState = ''
            },
        }

        this.$scope.closeButtonOptions = {
            template: TemplateHelper.getIcon(ConfigHelper.Icon.CLOSE, this.userSession),
            onClick: (e: any) => this.closePopup(),
        }

        this.$scope.toolbarOptions = {

            items: [
                <dxToolbarOptions>{
                    location: 'after',
                    widget: 'dxButton',
                    options: {
                        bindingOptions: {
                            visible: 'isEditAllowed && isSupportedType'
                        },
                        text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Apply),
                        onClick: (): void => {
                            this.submit()
                        },
                    },
                },
            ],
        }

        this.$scope.configurationProfileCreateEditAccordionsOptions = {
            disableCollapsing: false,
            onInitialized: (e: any) => {
                this.onAccordionInitialized(e)
            }
        }

        this.$scope.configurationProfileBaseParametersFormAccordionItemOptions = {
            expanded: true,

            toolbar: {
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.BasicParameters),
            },
        }

        this.$scope.configurationProfileSettingsAccordionItemOptions = {
            expanded: false,

            toolbar: {
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Parameters),
            },
        }

        //#region  create-edit-popup

        this.$scope.getCoords = (): OpCoord => {
            return this.getCoords()
        }

        this.$scope.onLocationSelected = (lat: number, lng: number): void => {
            this.onLocationSelected(lat, lng)
        }

        this.$scope.onPopoverValueIdSelected = (valueId: number, datatypeId: number = null, value: string = null): void => {
            this.onPopoverValueIdSelected(valueId, datatypeId)

            this.selectedPopoverData = this.selectedPopoverData.filter((item: SelectPopoverData) => {
                return item.dataTypeId != datatypeId
            })
            this.selectedPopoverData.push({ valueId: valueId, dataTypeId: datatypeId, value: value })
        }

        //change previouse location data
        this.$scope.confirmNoChangePrevLocationData = (): void => {
            this.$scope.panels[0].formData[CommonHelper.locationCity] = this.$scope.locationData.city
            this.$scope.panels[0].formData[CommonHelper.locationAddress] = this.$scope.locationData.address
            this.$scope.panels[0].formData[CommonHelper.locationZip] = this.$scope.locationData.zip

            this.$scope.panels[0].formData[CommonHelper.locationLatitude] = this.$scope.locationData.lat
            this.$scope.panels[0].formData[CommonHelper.locationLongitude] = this.$scope.locationData.lng

            this.$scope.$broadcast(EventsNames.UPDATE_COORDINATES_BUTTON_POPUP, this.$scope.getCoords())

            this.getCoords()
        }
        
        //#endregion
    }

    private setConfigurationProfileScheduleOptions(): void {
        this.$scope.configurationProfileScheduleOptions = {
            dataSource: this.getScheduleData(this.referenceObject as OpConfigurationProfile),
            onInitialized: (e: IMRConfigurationProfileScheduleInitializedArgs) => {
                this.configurationProfileSchedule = e.component
            },

        }
    }

    private getScheduleData(configurationProfile: OpConfigurationProfile): OpConfigurationProfileData[] {
        if (configurationProfile == null) {
            return []
        }

        const workDayScheduleData: OpConfigurationProfileData[] = configurationProfile.dataList.getDataList(Enums.DataType.DALI_WORKDAY_POWER_LEVEL)
        const weekEndScheduleData: OpConfigurationProfileData[] = configurationProfile.dataList.getDataList(Enums.DataType.DALI_WEEKEND_POWER_LEVEL)
        const holidayScheduleData: OpConfigurationProfileData[] = configurationProfile.dataList.getDataList(Enums.DataType.DALI_HOLIDAY_POWER_LEVEL)

        return [...workDayScheduleData, ...weekEndScheduleData, ...holidayScheduleData]
    }

    // #endregion

    //#region runtime

    private closePopup(): void {
        this.isClosed = true

        this.$scope.popupVisible = false
        if (this.$scope != null && this.$scope.options != null && this.$scope.options.onClose != null && TypeHelper.isFunction(this.$scope.options.onClose)) {
            this.$scope.options.onClose()
        }

        this.isClosed = true
        this.$scope.panels = []
        this.selectedPopoverData = []

        this.$scope.configurationProfileScheduleOptions = null
        this.configurationProfileSchedule = null
    }

    private onShowCreateEditPopup(): void {
        this.editedItems = {}

        this.isClosed = false
        this.$scope.popupVisible = true
        this.$scope.isLoading = true
        this.$scope.noData = false
    }

    private onCloseCreateEditPopup(args: any[]): void {
        if (_.size(args) > 0) {
            this.isClosed = true

            const needClosePopup: boolean = args[1]

            if (needClosePopup != false) {
                this.$scope.popupVisible = false

                this.$scope.configurationProfileScheduleOptions = null
                this.configurationProfileSchedule = null
            }
        }
    }

    private onAccordionInitialized(e: any): void {
        this.accordion = e.component
    }

    private onShowPopup(args: any[]): void {
        this.$scope.isSupportedType = false

        if (_.size(args) > 0) {
            this.popup.show().then(() => {
                this.$scope.popupVisible = true
                const params: CreateEditInitParams = args[0]
                const sections: CreateEditSection[] = _.clone(params.sections)
                let initialData: CreateEditField[]
                this.idReferenceType = params.idReferenceType
                let selectedTab: number

                const opObject: IOpObject = params.referenceObject
                this.referenceObject = params.referenceObject
                const dataTypeDict: Dictionary<OpDataType> = new Dictionary<OpDataType>(null)

                this.prepareProfileDetailsParamsView()

                sections.forEach((section: CreateEditSection) => {
                    section.columns = section.dataTypesToEdit.map((c: OpDataTypeInGroup) => {
                        const opDataTypeInGroup: OpDataTypeInGroup = c
                        dataTypeDict.addOrUpdate(opDataTypeInGroup.idDataType, opDataTypeInGroup.dataType)

                        const settings = {
                            id: opDataTypeInGroup.idDataType,
                            caption: opDataTypeInGroup.toString(),
                            referenceTypeId: opDataTypeInGroup.dataType.idReferenceType, // ??
                            unitName: opDataTypeInGroup.dataType.unit.name, // usunąć
                            type: opDataTypeInGroup.dataType.idDataTypeClass, //??
                            format: opDataTypeInGroup.dataType.dataTypeFormat ? opDataTypeInGroup.dataType.dataTypeFormat : {}, //??
                            isEditable: opDataTypeInGroup.dataType.isEditable,
                        }

                        settings['defaultValue'] = opDataTypeInGroup.dataType.defaultValue

                        return settings as CreateEditFieldSettings
                    })

                    section.required = section.dataTypesRequired.map((c: OpDataTypeInGroup) => {
                        const opDataTypeInGroup: OpDataTypeInGroup = <any>c
                        return <CreateEditFieldSettings>{
                            id: opDataTypeInGroup.idDataType,
                            caption: opDataTypeInGroup.toString(),
                            referenceTypeId: opDataTypeInGroup.dataType.idReferenceType,
                            unitName: opDataTypeInGroup.dataType.unit.name,
                            type: opDataTypeInGroup.dataType.idDataTypeClass,
                            format: opDataTypeInGroup.dataType.dataTypeFormat ? opDataTypeInGroup.dataType.dataTypeFormat : {},
                            isEditable: opDataTypeInGroup.dataType.isEditable,
                        }
                    })
                })

                if (opObject) {
                    initialData = opObject.dataList
                        .toArray()
                        .map((d: IOpData) => {
                            const dataType: OpDataType = dataTypeDict.tryGetValue(d.idDataType)
                            if (dataType) {
                                return <CreateEditField>{
                                    id: d.idData,
                                    idDataType: d.idDataType,
                                    index: d.indexNBR,
                                    name: d.idDataType + '',
                                    value: d.value,
                                    typeId: dataType ? dataType.idDataTypeClass : 0,
                                    rowColor: (<any>d).statusColor,
                                }
                            }
                            return null
                        })
                        .filter((d: CreateEditField) => d != null)
                }
                this.$scope.modelId = params.referenceObject ? params.referenceObject.getReferenceKey() : params.referenceObjectId
                selectedTab = params.createEditSelectedTabType

                this.originalData = _.clone(initialData)

                this.$timeout(() => {
                    if (selectedTab) {
                        this.$scope.selectedTab = selectedTab
                    } else {
                        this.$scope.selectedTab = 0
                    }

                    if (this.accordion != null) {
                        this.accordion.updateDimensions()
                    }
                }, 500)

                if (!sections || sections.length == 0) {
                    this.$scope.noData = true
                } else {
                    sections.forEach((section: CreateEditSection) => {
                        if (section.dataTypesToEdit != null && section.dataTypesToEdit.length === 0) {
                            sections.splice(sections.indexOf(section), 1)
                        }
                    })
                }

                this.entityId = this.$scope.modelId

                this.$scope.panels = []

                const mappedData: { [key: number]: CreateEditField } = {}

                if (initialData == null) {
                    initialData = []
                }

                initialData.forEach((data: CreateEditField) => {
                    if (data.index == 0) mappedData[data.idDataType || data.id] = data
                })

                sections.forEach((section: CreateEditSection) => {
                    switch (section.type) {
                        default:
                        case 'form':
                            this.createForm(section, mappedData, this.idReferenceType)
                            break
                    }
                    this.$scope.panels.push(section)
                })

                this.$timeout(() => {
                    this.$scope.$root.$broadcast(EventsNames.UPDATE_COORDINATES_BUTTON_POPUP, this.$scope.getCoords())
                })
            })
        }
    }

    private prepareProfileDetailsParamsView(idType: number = null): void {
        this.$scope.isALAMPType = false
        this.userSession
            .getDataProvider()
            .System
            .getDictionaries([Enums.ReferenceType.IdConfigurationProfileType])
            .then((result: Dictionary<Dictionary<IReferenceType>>) => {
                if (this.referenceObject == null && idType == null) {
                    return
                }

                const idConfigurationProfileType: number = idType == null ? (this.referenceObject as OpConfigurationProfile).idConfigurationProfileType : idType
                const dictionay: Dictionary<IReferenceType> = result.tryGetValue(Enums.ReferenceType.IdConfigurationProfileType)

                if (dictionay == null) {
                    return
                }

                const target: OpConfigurationProfileType = dictionay.tryGetValue(idConfigurationProfileType) as OpConfigurationProfileType

                if (target == null) {
                    return
                }

                this.isEditAllowed()

                switch (target.name) {
                    case 'ALAMP':
                        this.$scope.isSupportedType = true
                        this.setConfigurationProfileScheduleOptions()
                        break
                    default:
                        this.$scope.isSupportedType = false
                        break
                }
            })
    }

    private isEditAllowed(): void {
        if (this.referenceObject == null) {
            this.$scope.isEditAllowed = true
        } else {
            this.$scope.isLoading = true
            this.userSession.getDataProvider().ConfigurationProfile.isConfigurationProfileUsed(this.referenceObject.idObject)
                .then((isProfileUsed: boolean) => {
                    this.$scope.isEditAllowed = !isProfileUsed
                })
                .always(() => {
                    this.$scope.isLoading = false
                })
        }
    }

    private createForm(section: CreateEditSection, data: { [key: number]: CreateEditField }, idReferenceType: number): void {
        section.formData = {}
        section.items = []

        section.onFieldChanged = (e: any, idDataType: number = null): void => {
            const dataField: string = idDataType || e.element.get(0).attributes['table-id'].nodeValue

            if (dataField) {
                let value: any = null

                if (e.selectedItem) {
                    let number: number = parseFloat(e.selectedItem.id)

                    if (
                        !isNaN(number)) { value = number }
                    else {
                        value = e.selectedItem.id
                    }
                }

                if (+dataField == Enums.DataType.HELPER_ID_CONFIGURATION_PROFILE_TYPE) {
                    this.prepareProfileDetailsParamsView(value)
                }

                this.updateFormData(section, dataField, value)
            }
        }

        section.onDateFieldChanged = (e: any): void => {
            this.trackChanges(section, e.element.get(0).attributes['table-id'].nodeValue, e.value)
        }

        section.onFieldValueChanged = (e: any): void => {
        } //empty but probaly necessary to avoid error

        section.initializedHandler = (e: any): void => { } //empty but probaly necessary to avoid error

        section.onSelectNoteValueChanged = (value: ChangeStatusSelectItem, idDataType: Enums.DataType): void => {
            if (value != null) {
                $('[table-id=' + idDataType + '] .dx-dropdownbox').removeClass('dx-invalid')

                this.updateFormData(section, idDataType, value.value)
            }
        }

        section.onNoteValueChanged = (value: string, idDataType: Enums.DataType): void => {
            if (value != null) {
                this.updateFormData(section, idDataType, value)
            }
        }

        section.options = null
        this.$timeout(() => {
            section.options = this.getFormOptions(section, data, idReferenceType)
        })
    }

    private trackChanges(section: CreateEditSection, idDataType: number, value: any, index: number = 0): void {
        this.$scope.panels.forEach((panel: CreateEditSection) => {
            if (panel != section) {
                if (panel.form && index == 0 && panel.columns.map((c) => c.id).indexOf(idDataType) > -1) {
                    // if (idDataType == CommonHelper.distributorColumnId && this.distributorFormInstance) {
                    // 	this.hideDistributorChangePopup = true
                    // 	this.distributorFormInstance.option('value', value)
                    // 	this.hideDistributorChangePopup = false
                    // }

                    if (panel.formData[idDataType] != value) {
                        this.editedItems[idDataType] = true
                        panel.formData[idDataType] = value
                    }
                }
            }
        })
    }

    private getId(index: number, idDataType: number): number {
        if (this.originalData != null) {
            const models: CreateEditField[] = this.originalData.filter((d: CreateEditField) => d.index == index && d.idDataType == idDataType)
            if (models.length > 0) {
                return models[0].id
            }
        }
        return null
    }

    private updateFormData(section: CreateEditSection, dataField: string | number, value: any): void {
        if (section.formData[dataField] !== value) {
            section.formData[dataField] = value
            this.editedItems[dataField] = true
        }
    }

    private getFormOptions(section: CreateEditSection, data: { [key: number]: CreateEditField }, idReferenceType: number): dxFormOptions {
        const formOptions: dxFormOptions = {
            requiredMark: '*',
            showRequiredMark: true,
            labelLocation: 'top',
            width: '100%',
            height: '100%',
            scrollingEnabled: true,
            colCount: 4,
            bindingOptions: {
                formData: 'panel.formData',
                items: 'panel.items',
            },
            onInitialized: (e: any): void => {
                section.form = e.component

                this.$timeout(() => {
                    this.loadForm(section, data, this.$scope.options.type, idReferenceType)
                })

                //dedicated
                if (
                    section.formData != null &&
                    !section.formData[Enums.DataType.LOCATION_WARRANTY_DATE] &&
                    section.columns.some((column: CreateEditFieldSettings) => column.id == Enums.DataType.LOCATION_WARRANTY_DATE)
                ) {
                    const d: Date = new Date()
                    section.formData[Enums.DataType.LOCATION_WARRANTY_DATE] = new Date(d.getFullYear() + 2, d.getMonth(), d.getDate())
                }
            },
            onFieldDataChanged: (e: any): void => {
                this.onSectionFieldDataChanged(data, e.dataField, e.value)
                this.trackChanges(section, e.dataField, e.value)
            },
        }
        return formOptions
    }

    private onSectionFieldDataChanged(data: { [key: number]: CreateEditField }, dataField: number, value: any): void {
        if (data[dataField]) {
            let oldValue: any = data[dataField].value
            if (data[dataField].typeId == CommonHelper.datetime || data[dataField].typeId == CommonHelper.date) {
                oldValue = moment(oldValue).toDate()
                if (oldValue != null || value == null || oldValue == null || value != null || (oldValue != null && value != null && oldValue.getTime() != value.getTime())) {
                    this.editedItems[dataField] = true
                } else if (oldValue.getTime() == value.getTime()) {
                    this.editedItems[dataField] = false
                }
            } else {
                if (oldValue != value) {
                    this.editedItems[dataField] = true
                } else if (oldValue == value) {
                    this.editedItems[dataField] = false
                }
            }
        }
    }

    private onPopoverValueIdSelected(valueId: number, datatypeId): void {
        this.$scope.panels.forEach((panel: CreateEditSection) => {
            if (panel.form != null && panel.formData != null) {
                if (panel.formData[datatypeId] !== undefined) {
                    if (valueId) {
                        angular
                            .element('.data_type_id_' + datatypeId)
                            .find('.dx-invalid')
                            .removeClass('dx-invalid')
                    }
                    panel.formData[datatypeId] = valueId
                    this.editedItems[datatypeId] = true
                }
            }
        })
    }

    private onLocationSelected(lat: number, lng: number): void {
        if (this.$scope.locationData == null) {
            this.$scope.locationData = {}
        }

        this.$scope.panels.forEach((panel: CreateEditSection) => {
            if (panel.form != null && panel.formData != null) {
                this.$scope.locationData.lat = panel.formData[CommonHelper.locationLatitude]
                this.$scope.locationData.lng = panel.formData[CommonHelper.locationLongitude]

                panel.formData[CommonHelper.locationLatitude] = lat
                panel.formData[CommonHelper.locationLongitude] = lng
                this.editedItems[CommonHelper.locationLatitude] = true
                this.editedItems[CommonHelper.locationLongitude] = true
            }
        })
    }

    private getCoords(): OpCoord {
        let latitude: number
        let longitude: number
        this.$scope.panels.forEach((panel: CreateEditSection) => {
            if (panel.formData == null) {
                return
            }

            const lat: number = panel.formData[CommonHelper.locationLatitude]
            const lng: number = panel.formData[CommonHelper.locationLongitude]
            if (lat != null && lng != null) {
                latitude = lat
                longitude = lng
            }
        })
        if (latitude != null && longitude != null) {
            let coord: OpCoord = new OpCoord()
            coord.latitude = latitude
            coord.longitude = longitude
            return coord
        }
        return null
    }

    //#endregion    

    private submit() {
        const sections: CreateEditSection[] = this.$scope.panels

        if (this.isSectionsValid(sections) == true) {
            let unique: { index: number; idDataType: number }[] = []
            let fields: FieldNameValueModel[] = []

            sections.forEach((section: CreateEditSection) => {
                if (section.form != null) {
                    Object.keys(section.formData).forEach((property: string) => {
                        let idDataType: number = parseInt(property)
                        if (unique.filter((o: { index: number; idDataType: number }) => o.index == 0 && o.idDataType == idDataType).length == 0) {
                            const id: number = this.getId(0, idDataType)
                            let state: Enums.OpChangeState = Enums.OpChangeState.New
                            let isHelperField: boolean = false
                            const dataType: OpDataType = this.userSession.getDataProvider().DataType.getDataTypeLocal(idDataType)

                            if (dataType != null) {
                                isHelperField = dataType.name.indexOf('HELPER_') == 0
                            }

                            if (id || isHelperField) {
                                if (this.editedItems[idDataType]) {
                                    state = Enums.OpChangeState.Modified
                                } else {
                                    state = Enums.OpChangeState.Loaded
                                }
                            }

                            let nameValue: FieldNameValueModel = new FieldNameValueModel()
                            nameValue.idDataType = idDataType
                            nameValue.id = id ? id : 0
                            nameValue.index = 0
                            nameValue.value = section.formData[property]

                            if (dataType != null) {
                                nameValue.value = ConvertHelper.prepareDataValue(nameValue.value, dataType)
                            }

                            nameValue.state = state
                            fields.push(nameValue)
                            unique.push({ index: 0, idDataType: idDataType })
                        }
                    })
                }
            })

            let currentMd5: string = Md5.init({ fields, entityId: this.entityId })

            if (this.previousSectionState !== currentMd5 || this.submitFailed) {
                this.$scope.isLoading = true
                this.previousSectionState = currentMd5
                this.isSaveAllowed = false

                const objectToSave: OpConfigurationProfile = <OpConfigurationProfile>(<any>ReferenceTypeComponent.createReferenceObject(this.idReferenceType, {}))
                objectToSave.idObject = this.entityId
                objectToSave.dataList = new OpDataList<OpConfigurationProfileData>()

                //#region fill base parameters

                objectToSave.opState = objectToSave.idObject == 0 ? Enums.OpChangeState.New : Enums.OpChangeState.Modified

                if (this.referenceObject != null) {
                    if ((<OpConfigurationProfile>this.referenceObject).createdTime != null) {
                        objectToSave.createdTime = (<OpConfigurationProfile>this.referenceObject).createdTime
                    }

                    if ((<OpConfigurationProfile>this.referenceObject).idDescr != null) {
                        objectToSave.idDescr = (<OpConfigurationProfile>this.referenceObject).idDescr
                    }

                    if ((<OpConfigurationProfile>this.referenceObject).idDistributor != null) {
                        objectToSave.idDistributor = (<OpConfigurationProfile>this.referenceObject).idDistributor
                    }

                    if ((<OpConfigurationProfile>this.referenceObject).idOperatorCreated != null) {
                        objectToSave.idOperatorCreated = (<OpConfigurationProfile>this.referenceObject).idOperatorCreated
                    }

                    if ((<OpConfigurationProfile>this.referenceObject).name != null) {
                        objectToSave.name = (<OpConfigurationProfile>this.referenceObject).name
                    }
                }

                if (objectToSave.opState == Enums.OpChangeState.New) {
                    objectToSave.idOperatorCreated = this.userSession.getLoggedOperator().idOperator
                    objectToSave.idDistributor = this.userSession.getLoggedOperator().idDistributor
                    objectToSave.createdTime = new Date()
                    objectToSave.name = 'not defined name'
                }

                //#endregion

                //#region base dataType fields

                fields.forEach((f: FieldNameValueModel) => {
                    const objectDataToSave: OpConfigurationProfileData = new OpConfigurationProfileData(null)
                    objectDataToSave.idDataType = f.idDataType
                    objectDataToSave.indexNBR = f.index
                    objectDataToSave.value = f.value
                    objectDataToSave.opState = f.state
                    objectToSave.dataList.push(objectDataToSave)

                    if (f.idDataType == Enums.DataType.HELPER_ID_CONFIGURATION_PROFILE_TYPE && f.value != null) {
                        objectToSave.idConfigurationProfileType = f.value
                    }

                    if (f.idDataType == Enums.DataType.HELPER_ID_DISTRIBUTOR && f.value != null) {
                        objectToSave.idDistributor = f.value
                    }

                    if (f.idDataType == Enums.DataType.HELPER_ID_OPERATOR_CREATED && f.value != null) {
                        objectToSave.idOperatorCreated = f.value
                    }

                    if (f.idDataType == Enums.DataType.HELPER_NAME && f.value != null) {
                        objectToSave.name = f.value
                    }
                })

                //#endregion

                if (this.configurationProfileSchedule != null) {
                    const scheduleData: IIMRConfigurationProfileScheduleSubmitResponse = this.configurationProfileSchedule.submit()

                    if (scheduleData.isValid) {
                        this.isSaveAllowed = true
                        objectToSave.dataList.push(...scheduleData.data)

                        if (objectToSave.configuationProfileFuntionsDescr != null) {
                            objectToSave.configuationProfileFuntionsDescr.description = scheduleData.htmlString
                            objectToSave.configuationProfileFuntionsDescr.opState = Enums.OpChangeState.Modified
                        } else {
                            const descr: OpDescr = new OpDescr()
                            descr.opState = objectToSave.idDescr > 0 ? Enums.OpChangeState.Modified : Enums.OpChangeState.New
                            descr.description = scheduleData.htmlString
                            descr.idDescr = objectToSave.idDescr
                            descr.idLanguage = this.userSession.getDataProvider().System.getCurrentLanguageId()

                            objectToSave.configuationProfileFuntionsDescr = descr
                        }
                    }
                }

                if (this.isSaveAllowed == true) {
                    setTimeout(() => {
                        this.$scope.options
                            .onSave(objectToSave)
                            .then((result: IOpObject) => {
                                if (!result) {
                                    this.submitFailed = true
                                } else {
                                    this.submitFailed = false
                                }
                            })
                            .catch(() => {
                                this.submitFailed = true
                            })
                            .finally(() => {
                                setTimeout(() => {
                                    this.$scope.isLoading = false
                                }, 100)
                            })
                    })
                } else {
                    this.submitFailed = true
                    this.$scope.isLoading = false
                }
            }
        } else {
            ToastHelper.showError(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IncorrectData), { displayTime: 5000 })
            angular.element('.dx-invalid').css('height', '36px')
        }
    }
}